<template>
  <div class="call-to-action">
    <h1>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 36C0 26.4522 3.79285 17.2955 10.5442 10.5442C17.2955 3.79285 26.4522 0 36 0C45.5478 0 54.7045 3.79285 61.4558 10.5442C68.2072 17.2955 72 26.4522 72 36C72 45.5478 68.2072 54.7045 61.4558 61.4558C54.7045 68.2072 45.5478 72 36 72C26.4522 72 17.2955 68.2072 10.5442 61.4558C3.79285 54.7045 0 45.5478 0 36ZM26.568 23.3865C26.3604 23.1716 26.1122 23.0002 25.8377 22.8823C25.5632 22.7644 25.2679 22.7023 24.9692 22.6997C24.6704 22.6971 24.3741 22.754 24.0976 22.8672C23.8211 22.9803 23.5699 23.1474 23.3586 23.3586C23.1474 23.5699 22.9803 23.8211 22.8672 24.0976C22.754 24.3741 22.6971 24.6704 22.6997 24.9692C22.7023 25.2679 22.7644 25.5632 22.8823 25.8377C23.0002 26.1122 23.1716 26.3604 23.3865 26.568L41.8185 45H29.3625C28.7658 45 28.1935 45.2371 27.7715 45.659C27.3496 46.081 27.1125 46.6533 27.1125 47.25C27.1125 47.8467 27.3496 48.419 27.7715 48.841C28.1935 49.2629 28.7658 49.5 29.3625 49.5H47.25C47.8467 49.5 48.419 49.2629 48.841 48.841C49.2629 48.419 49.5 47.8467 49.5 47.25V29.3625C49.5 28.7658 49.2629 28.1935 48.841 27.7715C48.419 27.3496 47.8467 27.1125 47.25 27.1125C46.6533 27.1125 46.081 27.3496 45.659 27.7715C45.2371 28.1935 45 28.7658 45 29.3625V41.8185L26.568 23.3865Z"
          fill="#e2b6ff"
        />
      </svg>
      How It Works
    </h1>
  </div>
</template>

<script>
export default {
  name: "HowItWorks"
};
</script>

<style lang="scss" scoped>
.call-to-action {
  min-height: 220px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 38px;
    color: #445a64;
    margin-bottom: 16px;
  }
}
@media (max-width: 640px) {
  .call-to-action {
    min-height: unset;
    padding-top: 30px;
    svg {
      height: 46px;
      width: 46px;
    }
  }
}
</style>
